<template>
  <div class="">
    <template v-if="canDelete">
      <div>
        <p>
          Are you sure you want to delete your review of
          <span class="font-bold">{{ review.title_title }}</span>
        </p>
        <p class="text-sm italic">This can't be undone</p>
      </div>

      <div class="flex justify-end mt-8">
        <button
          v-if="!formBusy"
          type="button"
          class="flex gap-x-2 justify-between items-center py-3 px-4 w-full text-sm font-semibold text-center text-white from-red-500 to-purple-800 rounded-lg border border-transparent transition ease-in-out bg-linear-to-r hover:from-red-600 hover:to-purple-400 disabled:opacity-50 disabled:pointer-events-none"
          @click.prevent="deleteReview">
          Delete <fa-icon icon="trash" class="fa-fw" />
        </button>

        <button
          v-else
          type="button"
          class="flex gap-x-2 justify-between items-center py-3 px-4 w-full text-sm font-semibold text-center text-white from-red-500 to-purple-800 rounded-lg border border-transparent transition ease-in-out bg-linear-to-r hover:from-red-600 hover:to-purple-400 disabled:opacity-50 disabled:pointer-events-none">
          Deleting..
          <fa-icon icon="spinner-third" class="fa-spin fa-fw" />
        </button>

        <div
          v-if="formError"
          class="p-2 my-2 text-xs bg-red-500 rounded-sm cursor-pointer hover:bg-red-600"
          @click.prevent="clearFormError">
          Error deleting review: {{ formError }}
        </div>
      </div>
    </template>
    <template v-else>
      <p>
        Sorry, you cannot delete this review of
        <span class="font-bold">{{ review.title_title }}</span>
      </p>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStoreAuth } from '@/stores/storeAuth'
import { useStoreReviews } from '@/stores/storeReviews'

const formBusy = ref(false)
const formError = ref(null)
const storeAuth = useStoreAuth()
const storeReviews = useStoreReviews()

const props = defineProps({
  review: Object
})

const emit = defineEmits({
  success: null
})

const canDelete = computed(() => {
  if (props.review.user_id === storeAuth.user.id) {
    return true
  }
  return false
})

const deleteReview = async () => {
  formBusy.value = true
  formError.value = null

  const { error } = await storeReviews.deleteReview(props.review.id)

  if (error) {
    formError.value = error
    formBusy.value = false
    return
  } else {
    formBusy.value = false
    emit('success')
  }
}

const clearFormError = () => {
  formError.value = null
}
</script>
